export default class EventViewController {
    constructor($routeParams, $location, $route, eventService, exerciseService, userService, authenticationService, channelsService, $mdDialog, notificationsService, globalConstants) {
        this.$location = $location;
        this.eventService = eventService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.channelsService = channelsService;
        this.$mdDialog = $mdDialog;
        this.$routeParams = $routeParams;
        this.$route = $route;
        this.globalConstants = globalConstants;
        this.notificationsService = notificationsService;
        this.exerciseService = exerciseService;

        eventService.get($routeParams.eventId).then(resp => {
            this.event = resp.data;
            
            this.eventName = this.event.name;
            this.eventPostcode = this.event.postcode;
            this.eventDate = this.event.date;

            this.userService.getByIds({ids: this.event.eventUsers}).then(resp => {
                this.event.eventUsers = resp.data;
            });

            this.channelsService.getByIds({ids: this.event.eventChannels}).then(resp => {
                this.event.eventChannels = resp.data;
            });
        }, error => {
            $location.path("/");
        });

        exerciseService.getByEventId({ eventId : $routeParams.eventId }).then(resp => {
            this.exercises = resp.data;
        }, error => {
            $location.path("/");
        });
    }

    onSave(){
            this.event.eventUsers = [];
            this.event.eventChannels = [];
            this.eventService.updateEvent(this.event).then(resp => {
                this.$route.reload();
                this.notificationsService.show("Event updated", "success");
            },
            resp => {
                this.notificationsService.show("Event not updated", "error");
            });
    }

    duplicateExercise(id){
        this.exerciseService.duplicateExercise(id).then(resp=> {
            this.$route.reload();
                this.notificationsService.show("Exercise duplicated", "success");
            },
            resp => {
                this.notificationsService.show("Exercise not duplicated", "error");
            });
    }

    moveUp(index) {
        if (index > 0) {
            var temp = this.exercises[index];
            this.exercises[index] = this.exercises[index - 1];
            this.exercises[index - 1] = temp;
            this.saveOrder();
        }
    };

    moveDown(index) {
        if (index < this.exercises.length - 1) {
            var temp = this.exercises[index];
            this.exercises[index] = this.exercises[index + 1];
            this.exercises[index + 1] = temp;
            this.saveOrder();
        }
    };

    saveOrder() {
        let payload = {};
        this.exercises.map(function(exercise, index) {
            payload[exercise.id] = index;
        });

        this.exerciseService.saveOrder(payload).then(resp=> {
                this.notificationsService.show("Position updated", "success");
            },
            resp => {
                this.notificationsService.show("Position update failed", "error");
            });

    };

    assignUser(ev) {
        let that = this;
        var selectedUsers = [];
        for(var eventUser of that.event.eventUsers) {
            selectedUsers.push(eventUser);
        }
        this.$mdDialog.show({
            controller: AssignUserDialogController,
            templateUrl: '/views/components/events/events.view.assignuser.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                selected: selectedUsers
            }
          })
          .then(function(users) {

            var i = 0;
            function assignUser(user) {
                var eventUser = {
                    eventId: that.$routeParams.eventId,
                    userId: user.id
                };
                that.eventService.assignTrainee(eventUser).then(resp => {
                    eventUser.user = user;
                    if(i == users.length - 1) {
                        that.$route.reload();
                        that.notificationsService.show(`Trainee${users.length > 1 ? 's' : ''} assigned to event`, "success")
                    } else {
                        assignUser(users[++i])
                    }
                });
            }

            if(users.length > 0)
                assignUser(users[0]);
          }, function() {
            
          });
    }

    unassignUser(user, index) {
        var eventUser = {
            eventId: this.$routeParams.eventId,
            userId: user.id
        };
        this.eventService.unassignTrainee(eventUser).then(resp => {
            this.$route.reload();
        });
    }

    assignChannel(ev) {
        let that = this;
        var selectedChannels = [];
        for(var eventChannel of that.event.eventChannels) {
            selectedChannels.push(eventChannel);
        }
        this.$mdDialog.show({
            controller: AssignChannelDialogController,
            templateUrl: '/views/components/events/events.view.assignchannel.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                selected: selectedChannels
            }
          })
          .then(function(channels) {
            var i = 0;
            function assignChannel(channel) {
                var eventChannel = {
                    eventId: that.$routeParams.eventId,
                    channelId: channel.id
                };
                that.channelsService.assignChannel(eventChannel).then(resp => {
                    eventChannel.channel = channel;
                    if(i == channels.length - 1) {
                        that.$route.reload();
                        that.notificationsService.show(`Channel${channels.length > 1 ? 's' : ''} assigned to event`, "success")
                    } else {
                        assignChannel(channels[++i])
                    }
                });
            }

            if(channels.length > 0)
                assignChannel(channels[0]);
          }, function() {
            
          });
    }

    unassignChannel(channel, index) {
        var eventChannel = {
            eventId: this.$routeParams.eventId,
            channelId: channel.id
        };
        this.channelsService.unassignChannel(eventChannel).then(resp => {
            this.$route.reload();
        });
    }



    delete() {
        this.eventService.delete(this.$routeParams.eventId).then(resp => {
            this.$location.path("/manage/clients/edit/" + this.$routeParams.clientId);
            this.notificationsService.show("Event deleted", "success");
        });
    }

    editEvent() {
        this.$location.path("/manage/events/edit/" + this.$routeParams.eventId);
    }

    showWarning(ev) {
        this.$mdDialog.show({
            contentElement: '#deleteEventDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };

    hideWarning(ev) {
        this.$mdDialog.hide({
            contentElement: '#deleteEventDialog',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true
        });
    };
}

class AssignUserDialogController {
    constructor($scope, $routeParams, userService, $mdDialog, selected) {
        $scope.ctrl = this;
        this.$mdDialog = $mdDialog;

        userService.getByClientId({ clientId: $routeParams.clientId, userType: 16 }).then(resp => {
            this.users = [];
            for(let user of resp.data) {
                let alreadySelected = false;
                for(let selectedUser of selected) {
                    if(user.id == selectedUser.id)
                        alreadySelected = true;
                }
                if(!alreadySelected)
                {
                    this.users.push(user);
                }
            }
        });
    }

    accept() {
        var assignedUsers = this.users.filter(f => f.assign == true);
        this.$mdDialog.hide(assignedUsers);
    }

    cancel() {
        this.$mdDialog.cancel();
    }
}


class AssignChannelDialogController {
    constructor($scope, $routeParams, channelsService, $mdDialog, selected) {
        $scope.ctrl = this;
        this.$mdDialog = $mdDialog;

        channelsService.getBySubscriptionId().then(resp => {
            this.channels = [];
            for(let channel of resp.data) {
                let alreadySelected = false;
                for(let selectedChannel of selected) {
                    if(channel.id == selectedChannel.id)
                        alreadySelected = true;
                }
                if(!alreadySelected)
                {
                    this.channels.push(channel);
                }
            }
        });
    }

    accept(channel) {
        var assignedChannels = this.channels.filter(f => f.assign == true);
        this.$mdDialog.hide(assignedChannels);
    }

    cancel() {
        this.$mdDialog.cancel();
    }
}


// WEBPACK FOOTER //
// ./src/js/components/events/events.view.controller.js